import { render } from "./AppMnews.vue?vue&type=template&id=03e872e4"
import script from "./AppMnews.vue?vue&type=script&lang=js"
export * from "./AppMnews.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__